<template>
  <!-- 我的积分 -->
  <div>
    <el-row>
      <el-col :span="17" style="padding-top: 25px">
        <div class="redPack_right">
          <div class="my-title">我的积分</div>
          <div class="my_Redprice">
            <div class="red_tit">我的积分:</div>
            <div class="red_pri">
              {{ score }}
            </div>
          </div>
          <div class="my-title">积分明细</div>

          <!-- 表格  -->
          <div class="draftsTable">
            <el-table
              :data="tableDataList"
              :header-cell-style="{
                color: '#848484',
                background: '#f4f4f4',
                textAlign: 'center',
              }"
              border
              style="width: 100%"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                prop="createtime"
                label="日期"
                width="180"
                :formatter="dateFormat"
              >
              </el-table-column>
              <el-table-column prop="type_name" label="摘要" width="180">
              </el-table-column>
              <el-table-column prop="wallet" label="积分"> </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="shopp_pagination">
            <el-button
              size="small"
              style="width: 80px; height: 30px"
              @click="pervious"
              >上一页</el-button
            >
            <el-pagination
              ref="pageGroup"
              :current-page="currentPage"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              background
              layout="pager"
              :total="total"
            >
            </el-pagination>
            <el-button
              style="width: 80px; height: 30px"
              size="small"
              @click="next"
              >下一页</el-button
            >
          </div>
        </div>
      </el-col>
      <el-col :span="1">
        <div class="redPack_con"></div>
      </el-col>
      <el-col :span="6" style="padding-top: 25px">
        <div class="redPack_left">
          <div class="my-title">积分规则</div>
          <div class="red_rule">
           {{scoreRule}}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
import { shoproUser, userWalletLog,indexRule } from "@/api/index.js";

export default {
  data() {
    return {
      tableData: [],
      score: "",
      total: 1,
      currentPage: 1,
      pageSize: 4,
      scoreRule:""
    };
  },

  created() {
    this.getUser();
    this.getIntegral();
    this.getIndexRule()
  },

  methods: {
    //积分规则
    getIndexRule(){
        indexRule({}).then(res=>{
            console.log(res);
            if(res.code !==1){
                return
            }
            this.scoreRule = res.data.score

        })
    },
    //获取个人信息
    getUser() {
      shoproUser({}, header).then((res) => {
        if (res.code !== 1) {
          return;
        }
        this.score = res.data.score;
      });
    },
    //积分明细
    getIntegral() {
      userWalletLog(
        { wallet_type: "score", status: "all", page: 1 },
        header
      ).then((res) => {
        console.log(res);
        if (res.code !== 1) {
          return;
        }
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    dateFormat(row, column) {
      let date = row[column.property];
      //console.log(moment);
      if (date == undefined) {
        return "";
      }
      return this.moment(date*1000).format("YYYY.MM.DD");
    },
    //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
  },
  computed: {
    tableDataList: function () {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
};
</script>
<style lang="less" scoped>
.shopp_pagination {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.my-title {
  // height: 40px;
  font-size: 20px;
  padding: 0 10px;
  border-left: 5px solid #ff6701;
  margin-bottom: 10px;
  margin-left: 32px;
  line-height: 40px;
}
.redPack_right {
}
.redPack_con {
  background: color(#f5f5f5);
  height: 622px;
}
.redPack_left {
}
.el-col-17 {
  border: 1px solid #0097fe;
  height: 622px;
}
.el-col-6 {
  border: 1px solid #0097fe;
  height: 622px;
}
.my_Redprice {
  display: flex;
  width: 287px;
  height: 56px;
  background: #fff7f5;
  border-radius: 8px;
  border: 1px solid #ee626a;
  justify-content: space-around;
  align-items: center;
  margin-left: 50px;
  margin-bottom: 59px;
  .red_tit {
    width: 90px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #323232;
    line-height: 25px;
  }
  .red_pri {
    width: 59px;
    height: 30px;
    font-size: 20px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #fe911f;
    line-height: 30px;
  }
}
.red_rule {
  width: 207px;
  height: 398px;
  font-size: 14px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/integral.vue